import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ASKPC_FAQ_SECTIONS, MOCK_FAQ_SECTIONS } from '../mock/mock-faq';
import { FaqSection } from './faq.models';

@Injectable({ providedIn: 'root' })
export class FaqService {
  private readonly http = inject(HttpClient);

  private readonly isMockMode: boolean;

  constructor() {
    const doc = inject(DOCUMENT);
    const w = doc.defaultView;
    const search = w?.location?.search ?? '';
    const params = new URLSearchParams(search);
    const fromQuery = params.get('data');
    const fromStorage = w?.localStorage?.getItem('pc-Chat.dataSource');
    this.isMockMode =
      !environment.production && (fromQuery ?? fromStorage ?? 'api').toLowerCase() === 'mock';
  }

  getFaqs(isPreLoginPage: boolean): Observable<FaqSection[]> {
    if (isPreLoginPage) return of(ASKPC_FAQ_SECTIONS);
    if (this.isMockMode) return of(MOCK_FAQ_SECTIONS);
    return this.http.get<FaqSection[]>('/api/faqs');
  }
}
